import { createAction } from "redux-actions";

export const CAMPAIGN_LIST = "CAMPAIGN_LIST";
export const campaignList = createAction(CAMPAIGN_LIST);

export const CAMPAIGN_DETAILS = "CAMPAIGN_DETAILS";
export const campaignDetails = createAction(CAMPAIGN_DETAILS);

export const ADD_CAMPAIGN = "ADD_CAMPAIGN";
export const addCampaign = createAction(ADD_CAMPAIGN);

export const UPDATE_CAMPAIGN = "UPDATE_CAMPAIGN";
export const updateCampaign = createAction(UPDATE_CAMPAIGN);

export const DELETE_CAMPAIGN = "DELETE_CAMPAIGN";
export const deleteCampaign = createAction(DELETE_CAMPAIGN);

export const RUN_CAMPAIGN = "RUN_CAMPAIGN";
export const runCampaign = createAction(RUN_CAMPAIGN);

export const BULKSUBSCRIPTIONUPLOAD = "BULKSUBSCRIPTIONUPLOAD";
export const uploadBulkSubscription = createAction(BULKSUBSCRIPTIONUPLOAD);

export const BULKSUBSCRIPTIONPREVIEW = "BULKSUBSCRIPTIONPREVIEW";
export const previewBulkSubscription = createAction(BULKSUBSCRIPTIONPREVIEW);

export const RUNCSVCAMPAIGN = "RUNCSVCAMPAIGN";
export const runCsvCampaign = createAction(RUNCSVCAMPAIGN);

export const SMSANALYTICS = "SMSANALYTICS";
export const getSmsAnalytics = createAction(SMSANALYTICS);

export const EMAILANALYTICS = "EMAILANALYTICS";
export const getEmailAnalytics = createAction(EMAILANALYTICS);
